// ヒーロースライダー設定
// backgroundType: 'animation'（visualType: shippouGold / techMesh / shippou / wave / fuji）
//                 / 'image'（backgroundImage） / 'gradient'（backgroundGradient） / 'video'（backgroundVideo）
export const heroSliderData = [
  // 1枚目：案A 和モダン・金の七宝
  {
    id: 1,
    title: '日本の旅を世界へ',
    subtitle: '株式会社J・T・C　旅人倶楽部',
    buttonText: '新着情報',
    buttonAction: 'news',
    backgroundType: 'animation',
    visualType: 'shippouGold',
    textColor: '#ffffff',
    textPosition: 'center',
    titleFontFamily: "'Yu Mincho', 'YuMincho', 'Hiragino Mincho ProN', 'Noto Serif JP', serif",
  },

  // 2枚目：AYUBITO 多言語GPS音声ガイド（専用レイアウト）
  {
    id: 4,
    layout: 'ayubito',
    image: '/hero05-1.png',
    bgImage: '/hero-bg.png',
    ctaText: '公式サイトを見る',
    ctaUrl: 'https://web.ayubito.com',
  },

  // 3枚目：案D テック / DX グラデーション
  {
    id: 2,
    title: '旅を、アップデートする',
    subtitle: 'GPS音声ガイドと観光DXで、旅の体験をなめらかに。',
    buttonText: 'サービスを見る',
    buttonAction: 'work',
    backgroundType: 'animation',
    visualType: 'techMesh',
    textColor: '#ffffff',
    textPosition: 'center',
  },
];
